import React, {
  createRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import TableWithSearchAndPagination from "../../components/tableWithSearchAndPagination";
import Button from "../../components/button";
import WithHeaderSidebar from "../../layout/withHeaderSidebar";
import WithAuth from "../../layout/withAuth";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import TextInput from "../../components/textInput";
import CheckPermission from "../../components/checkPermission";
import { connect } from "react-redux";
import { handleDrawer } from "../../actions/userActions";
import { addDisease, deleteDisease, getDisease, updateDisease } from "../../services/disease";

const headings = [
  {
    label: "Disease Id",
    width: "20%",
    align: "left",
  },
  {
    label: "Disease Name",
    width: "60%",
    align: "left",
  },
  {
    label: "Actions",
    width: "20%",
    align: "center",
  },
];

const dataToShow = [
  {
    key: "id",
    align: "left",
  },
  {
    key: "diseaseName",
    align: "left",
  },
];

const Manage = ({ handleDrawer }) => {
  const [totalData, setTotalData] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [callbackAttributes, setCallbackAttributes] = useState({
    searchSend: "",
    perPage: "25",
    selectedPage: "0",
    sort: "",
  });
  const [rolesList, setFunctionalityList] = useState([]);
  const [diseaseInfo, setDiseaseInfo] = useState({
    id: 0,
    diseaseName: "",
  });
  const ref = useRef(createRef());
  const [openModal, setOpenModal] = useState(false);

  const displayFuncationalityList = useCallback(() => {
    setFunctionalityList([]);
    const { searchSend, selectedPage, perPage, sort } = callbackAttributes;
    let data = `searchKey=${searchSend}&page=${selectedPage}&size=${perPage}&sort=${sort}`;
    getDisease(data).then((res) => {
      if (res?.status === 200) {
        setFunctionalityList(res?.result?.diseaseData || []);
        setTotalData(res?.result?.getTotalRecords || 0);
        setTotalPages(res?.result?.getTotalPages || 0);
      } else {
        // props?.setSnackbar({
        //     showSnackbar: true,
        //     message: res?.message,
        //     variant: "error"
        // })
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callbackAttributes]);

  useEffect(() => {
    displayFuncationalityList();
  }, [displayFuncationalityList, callbackAttributes]);

  const handleDelete = (item) => {
    deleteDisease(item.id).then((res) => {
      if (res.status === 200) {
        displayFuncationalityList();
      }
    });
  };

  const handleEdit = (item) => {
    setDiseaseInfo({
      id: item.id,
      diseaseName: item.diseaseName,
    });
    setOpenModal(true);
  };

  const handleAddAndEdit = () => {
    const isValid = ref.current.validate();
    if (!isValid) {
      return;
    }
    if (diseaseInfo.id === 0) {
      addDisease({
        diseaseName: diseaseInfo.diseaseName,
      }).then((res) => {
        if (res.status === 201) {
          setOpenModal(false);
          displayFuncationalityList();
        }
      });
    } else {
      updateDisease(diseaseInfo.id, {
        diseaseName: diseaseInfo.diseaseName,
      }).then((res) => {
        if (res.status === 200) {
          setOpenModal(false);
          displayFuncationalityList();
        }
      });
    }
  };

  const handleModalClose = () => {
    setDiseaseInfo({
      functionalityId: 0,
      functionalityName: "",
    });
    setOpenModal(false);
  };
  return (
    <div className="h-full">
      <div className="p-5 sm:pl-8 sm:pt-7 sm:pb-[23px] flex items-center md:block gap-5">
        <button className="md:hidden" onClick={handleDrawer}>
          <i class="fa-solid fa-list"></i>
        </button>
        <p className="text-xl md:text-2xl md:leading-6 text-[#404040] font-bold">
          Disease
        </p>
      </div>
      <div className="bg-[#F7F8F9] sm:pt-[18px] p-5 sm:pl-7 sm:pr-11 sm:pb-9">
        <div className="bg-white w-full h-full shadow-[0px_9px_20px] shadow-[#2E235E1A] rounded-[15px]">
          <div className="flex flex-row items-center justify-between p-3 sm:p-7 border-b ">
            <p className="text-base md:text-xl leading-6 text-[#404040] font-bold">
              Disease  List
            </p>
            <CheckPermission module="Disease" permission="Add">
              <Button
                text="New Entry"
                onClick={() => {
                  setDiseaseInfo({
                    id: 0,
                    diseaseName: "",
                  });
                  setOpenModal(true);
                }}
              />
            </CheckPermission>
          </div>
          <div className="p-3 sm:p-7 sm:pt-5">
            <TableWithSearchAndPagination
              headings={headings}
              dataToShow={dataToShow}
              data={rolesList}
              totalData={totalData}
              totalPages={totalPages}
              actions={["delete", "edit"]}
              setCallbackAttributes={setCallbackAttributes}
              handleActionEdit={handleEdit}
              handleActionDelete={handleDelete}
              module="Disease"
              actionPermission={{
                edit: "Edit",
                delete: "Delete",
              }}
            />
          </div>
        </div>
      </div>
      <Dialog
        open={openModal}
        TransitionProps={{
          style: {
            height: "auto",
          },
        }}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle>
          <p className="text-base md:text-xl leading-6 text-[#404040] font-bold">
            {diseaseInfo.id === 0
              ? "Add Disease"
              : "Edit Disease"}
          </p>
        </DialogTitle>
        <DialogContent dividers>
          <TextInput
            validations={[
              { type: "required", message: "Please enter disease name" },
            ]}
            value={diseaseInfo.diseaseName}
            ref={ref}
            label="Disease Name"
            onChange={(name, value) => {
              setDiseaseInfo((prev) => {
                return {
                  ...prev,
                  diseaseName: value,
                };
              });
            }}
          />
        </DialogContent>
        <DialogActions>
          <div className="gap-2 flex">
            <Button text="Cancel" onClick={handleModalClose} />
            <Button
              text={diseaseInfo.id === 0 ? "Add" : "Edit"}
              onClick={handleAddAndEdit}
            />
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    doctorId: state.user.doctorId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleDrawer: () => dispatch(handleDrawer()),
  };
}
  ;
export default WithAuth(WithHeaderSidebar(connect(mapStateToProps, mapDispatchToProps)(Manage)));
